export default __webpack_public_path__ + "static/media/fish-rMAX.jpg.ba862eda.txt";